import NumberFlow from '@number-flow/react';

export const MoneyAmount = ({ className, value }) => (
  <NumberFlow
    className={className}
    value={value}
    format={{
      style: 'currency',
      currency: 'UAH',
      trailingZeroDisplay: 'stripIfInteger',
      currencyDisplay: 'narrowSymbol',
    }}
  />
);
